import { createFileRoute } from '@tanstack/react-router'
import { organizationUserSearchSchema } from '@/features/filter-organization-users/model/organizationUserSearch'
import { EdyEduOrganizationPage } from '@/pages/platform-users/ui/EdyEduOrganizationPage'

export const Route = createFileRoute('/edu-organizations_/$eduOrgId')({
  validateSearch: organizationUserSearchSchema,
  component: EdyEduOrganizationPage,
})
